import { render, staticRenderFns } from "./salesArea.vue?vue&type=template&id=fe434d5a&scoped=true"
import script from "./salesArea.vue?vue&type=script&lang=js"
export * from "./salesArea.vue?vue&type=script&lang=js"
import style0 from "./salesArea.vue?vue&type=style&index=0&id=fe434d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe434d5a",
  null
  
)

export default component.exports